import React, { useState, useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Mousewheel } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

import './PromoScroll.css';
import { Link } from 'react-router-dom';
import useWindowSize from '../../../../assets/hooks/useWindowSize';
import { IMG_PLACEHOLDER_PROMO } from '../../../../assets/utils/constants';

const getResponsiveImage = (slide, width) => {
  if (width >= 1024 && slide.image?.urls?.orig) {
    return slide.image.urls.orig;
  } else if (width >= 768 && width < 1024 && slide.image_tablet?.urls?.orig) {
    return slide.image_tablet.urls.orig;
  } else if (width < 768 && slide.image_mobile?.urls?.orig) {
    return slide.image_mobile.urls.orig;
  } else {
    return slide.image?.urls?.orig || IMG_PLACEHOLDER_PROMO;
  }
};

function SlideContent({ slide }) {
  const { width } = useWindowSize();
  const imageUrl = getResponsiveImage(slide, width);

  return (
    <>
      <h2 className='promo-scroll__slide-title'>{slide.title}</h2>
      <img
        className="promo-scroll__slide-img"
        src={imageUrl}
        alt=""
      />
    </>
  );
}

function PromoScroll({ item }) {
  const { width } = useWindowSize();
  const [mySwiper, setMySwiper] = useState(null);


  return (
    <div className='promo-scroll'>
      <div className='promo-scroll__slider'>
        <Swiper
          slidesPerView={"auto"}
          spaceBetween={width <= 650 ? 4 : 8}
          autoplay={{
            delay: 6000,
            disableOnInteraction: true,
          }}
          mousewheel={{ forceToAxis: true }}
          modules={[Mousewheel, Autoplay]}
          preventInteractionOnTransition={true}
          className="promo-scroll__slides"
          onInit={(sw) => setMySwiper(sw)}
        >
          {item.data.map((slide, i2) => (
            <SwiperSlide
              className="promo-scroll__slide"
              key={`promo-scroll-${item._id}-slide-${i2}`}
            >
              {slide.link ? (
                slide.link.startsWith('/') ? (
                  <Link to={slide.link} className='promo-scroll__slide-box'>
                    <SlideContent slide={slide} />
                  </Link>
                ) : (
                  <a
                    href={slide.link}
                    target='_blank'
                    rel='noreferrer'
                    className='promo-scroll__slide-box'
                  >
                    <SlideContent slide={slide} />
                  </a>
                )
              ) : (
                <div className='promo-scroll__slide-box'>
                  <SlideContent slide={slide} />
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* 
        The line container with a ref to measure its position.
        The blob moves absolutely within this line.
      */}
      <div className='promo-scroll__line'>
        <div
          className='promo-scroll__line-blob'
        />
      </div>
    </div>
  );
}

export default PromoScroll;
